export interface WebSdkInitOptions {
  verificationId: string;
}

export interface WebSdkEventHandlers {
  onError?: (error?: unknown) => void;
  onProcessCompleted?: () => void;
}

export const webSdkEventHandlersInitialValues: WebSdkEventHandlers = {
  onError: () => null,
  onProcessCompleted: () => null,
};
